function togglePrimitive(value) {
  if (typeof value === 'boolean') return !value;
  if (typeof value === 'number') return value === 1 ? 0 : 1;
  if (typeof value === 'string') {
    const normalized = value.toLowerCase();

    if (normalized === '1') return '0';
    if (normalized === '0') return '1';
    if (normalized === 'true') return 'false';
    if (normalized === 'false') return 'true';
    if (normalized === 'active') return 'Inactive';
    if (normalized === 'inactive') return 'Active';
  }

  return value;
}

export function extractEntityFromTogglePayload(payload, keys = []) {
  if (!payload || typeof payload !== 'object') return null;
  if (payload.id !== undefined && payload.id !== null) return payload;

  const candidates = ['data', ...keys];
  for (const key of candidates) {
    const candidate = payload[key];
    if (candidate && typeof candidate === 'object') {
      if (candidate.id !== undefined && candidate.id !== null) return candidate;
      if (candidate.data && typeof candidate.data === 'object' && candidate.data.id !== undefined && candidate.data.id !== null) {
        return candidate.data;
      }
    }
  }

  return null;
}

export function buildLocallyToggledEntity(entity) {
  if (!entity || typeof entity !== 'object') return entity;

  const next = { ...entity };

  if ('is_active' in next) next.is_active = togglePrimitive(next.is_active);
  if ('isActive' in next) next.isActive = togglePrimitive(next.isActive);
  if ('active' in next) next.active = togglePrimitive(next.active);

  if (typeof next.status === 'string') {
    const normalized = next.status.toLowerCase();
    if (normalized === 'active' || normalized === 'inactive') {
      next.status = togglePrimitive(next.status);
    }
  }

  return next;
}
